/* eslint-disable no-undef */
export default {
	name: "collection-orders",
	data() {
		return {
            company: {},
			orders: [],
			orderStatuses: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			collectionOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer",
					field: "registeredCompanyName"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Order Type",
					field: "orderType"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Vehicle",
					field: "vehicle"
				},
				{
					text: "Fleet Number",
					field: "fleetNumber"
				},
				{
					text: "Manifest Number",
					field: "manifestNumber"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "description"
				}
			],
			deliveryOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer",
					field: "registeredCompanyName"
				},
				{
					text: "Order Type",
					field: "orderType"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Expected Date Of Delivery",
					field: "expectedDeliveryDate"
				},
				{
					text: "Vehicle",
					field: "vehicle"
				},
				{
					text: "Driver",
					field: "driver"
				},
				// {
				// 	text: "Fleet Number",
				// 	field: "fleetNumber"
				// },
				// {
				// 	text: "Amount Ordered",
				// 	field: "quantity"
				// },
				// {
				// 	text: "Amount Dispensed",
				// 	field: "quantityDispensed"
				// },
				{
					text: "Customer Purchase Order Number",
					field: "customerPurchaseOrder"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "description"
				}
			],
			actionKeys:{
				viewOrder: "viewOrder",
				viewTrackingHistory: "viewTrackingHistory",
				documents: "documents",
				orderEnquiries: "orderEnquiries"
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: 1,
				companyId: null,
				orderStatusId: null
			},
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			shippingAddressSelectModal:{
				modalId: "selectShippingAddressForOrderModal",
				heading: "Select Shipping Address For Order",
				showModal: false,
				company: null
			},
			shippingAddressSelectedForOrder: null,
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			orderForCollectionModal: {
				modalId: "createOrderForCollectionModal",
				heading: "Create New Order For Collection",
				showModal: false,
				companyId: null
			},
			hasLoaded: false,
			loading: false
		};
	},
	methods: {
        getCompany(){
            customerService.getCompany().then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        this.company = successResponse.data.result;
                    }
                },
                errorResponse => {
                    console.log("error", errorResponse);
                    alert("Unexpected error occurred");
                }
            );
        },
		getCollectionOrders(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				orderStatusId: this.filter.orderStatusId,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			orderService.getCollectionOrders(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orders = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.orders.length; i++){
							if(this.orders[i].discountedAmount !== null){
								this.orders[i].totalAmount = this.orders[i].totalAmount - this.orders[i].discountedAmount;
							}
							if(this.orders[i].orderTypeId === orderHelper.orderType.delivery){
								this.orders[i].orderType = "Delivery";
							}
							if(this.orders[i].orderTypeId === orderHelper.orderType.collection){
								this.orders[i].orderType = "Collection";
							}
							this.orders[i].totalAsString = currencyHelper.numberToCurrency(this.orders[i].totalAmount);
							this.orders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnOrdersViewOrder"
								},
								{
									name: "View Tracking History",
									key: this.actionKeys.viewTrackingHistory,
									elementId: "btnOrdersViewTrackingHistory"
								}
							];
							// switch (this.orders[i].orderStatusId){
							// 	// case orderHelper.orderStatus.pending:
							// 	// 	this.orders[i].actions.push(
							// 	// 		{
							// 	// 			name: "Review Order",
							// 	// 			key: this.actionKeys.reviewOrder,
							// 	// 			elementId: "btnOrdersReviewOrders"
							// 	// 		}
							// 	// 	);
							// 	// 	break;
							// 	// case orderHelper.orderStatus.accepted:
							// 	// 	this.orders[i].actions.push(
							// 	// 		{
							// 	// 			name: "Schedule Order",
							// 	// 			key: this.actionKeys.scheduleOrder,
							// 	// 			elementId: "btnOrdersScheduleOrder"
							// 	// 		}
							// 	// 	);
							// 	// 	break;
							// 	// case orderHelper.orderStatus.scheduledForDelivery:
							// 	// 	this.orders[i].actions.push(
							// 	// 		{
							// 	// 			name: "View Order Schedule",
							// 	// 			key: this.actionKeys.viewOrderSchedule,
							// 	// 			elementId: "btnOrdersViewOrderSchedule"
							// 	// 		}
							// 	// 	);
							// 	// 	break;
							// 	// case orderHelper.orderStatus.scheduledDeliveryCancelled:
							// 	// 	this.orders[i].actions.push(
							// 	// 		{
							// 	// 			name: "View Reason For Cancellation",
							// 	// 			key: this.actionKeys.scheduledDeliveryCancelled,
							// 	// 			elementId: "btnOrdersViewReasonForCancellation"
							// 	// 		}
							// 	// 	);
							// 	// 	break;
							// 	// case orderHelper.orderStatus.rejected:
							// 	// 	this.orders[i].actions.push(
							// 	// 		{
							// 	// 			name: "View Reason For Rejection",
							// 	// 			key: this.actionKeys.viewReasonForRejection,
							// 	// 			elementId: "btnOrdersViewReasonForRejection"
							// 	// 		}
							// 	// 	);
							// 	// 	break;
							// }
							if(this.orders[i].orderStatusId === orderHelper.orderStatus.complete) {
								this.orders[i].actions.push(
									{
										name: "Documents",
										key: this.actionKeys.documents,
										elementId: "btnOrdersViewDocuments"
									}
								);
							}
							else {
								this.orders[i].actions.push(
									{
										name: "Order Enquiries",
										key: this.actionKeys.orderEnquiries,
										elementId: "btnOrdersOrderEnquiries"
									}
								);
							}
						}
						this.orders = dataTableHelper.castFieldValues(this.orders);
						this.filterStateChanged = false;
						//permissionsHelper.setControlsBasedOnPermissions();
						let self = this;
						setTimeout(function (){
							self.firstLoad = true;
						}, 500);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderStatuses(){
			this.orderStatuses = orderService.getCollectionOrderStatues();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({id: 0, text: "All"});
			this.filter.orderStatusId = this.orderStatuses[0].id;
			this.getCollectionOrders();
		},
		onFilterSearchClicked(){
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getCollectionOrders();
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getCollectionOrders();
		},
		onOrderStatusSelect(orderStatus){
			if(orderStatus.id !== this.filter.orderStatusId){
				this.filter.orderStatusId = orderStatus.id;
				this.filterStateChanged = true;
			}
			//this.filter.orderStatusId = orderStatus.id;
			console.log("order status change");
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
		},
		onOrderActionClicked(actionAndData){
			switch(actionAndData.action) {
				case this.actionKeys.viewOrder:
					this.$router.push("/orders/collection/viewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderCollectionId);
					break;
				case this.actionKeys.viewTrackingHistory:
					this.trackingHistoryModal.showModal = true;
					this.trackingHistoryModal.orderId = actionAndData.data.orderId;
					this.trackingHistoryModal.heading = "Tracking History - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					break;
				case this.actionKeys.documents:
					this.documentsModal.showModal = true;
					this.documentsModal.orderId = actionAndData.data.orderId;
					this.documentsModal.heading = "Order Documents - #" + actionAndData.data.orderId;
					break;
				case this.actionKeys.orderEnquiries:
					this.$router.push("/orders/orderEnquiryMessages/" + actionAndData.data.orderId + "/" + orderHelper.orderType.collection + "/" + actionAndData.data.orderStatusId);
					break;
			}
		},
		// onShippingAddressSelected(shippingAddress){
		// 	console.log("shippingAddress1", shippingAddress);
		// 	this.shippingAddressSelectedForOrder = shippingAddress;
		// 	this.shippingAddressSelectModal.showModal = false;
		// 	var self = this;
		// 	setTimeout(function(){
		// 		self.orderForCollectionModal.company = self.shippingAddressSelectModal.company;
		// 		self.orderForCollectionModal.showModal = true;
		// 	}, 500);
		// },
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		onAddOrderClick(){
			this.orderForCollectionModal.showModal = true;
		},
		onPlaceOrderForCollectionOkClicked(){
			this.orderForCollectionModal.showModal = false;
			this.getCollectionOrders();
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
		},
	},
	mounted: function () {
        this.getCompany();
		this.filter.orderStatusId = orderHelper.orderStatus.readyForCollection;
		console.log("orderStatusId", this.filter.orderStatusId)
		this.getOrderStatuses();
		storeState.setPageTitleAction("Orders - Collection");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Orders - Collection");
	}
};